import React, { useCallback } from 'react';

import { BannerAlert } from '@periodica/ui-kit';
import { useAlertContext } from '@hooks/useAlertContext';
import type { AlertArgs } from '@customTypes/alert';

export function Alert({ alert }: AlertArgs) {
  const { key, showAlert, text, bgColor, links } = alert;

  const { hiddenAlerts, hideAlert } = useAlertContext();

  const handleHideAlert = useCallback(() => {
    hideAlert(key);
  }, [hideAlert, key]);

  return (
    <BannerAlert
      show={showAlert && !hiddenAlerts.includes(key)}
      text={text}
      bgColor={bgColor}
      links={links}
      onClose={handleHideAlert}
    />
  );
}
